const AUTH_ME = 'AUTH_ME';
const USER_DESIGNATION = 'USER_DESIGNATION';
const GET_HOLIDAY = 'GET_HOLIDAY';
const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
const LANGUAGES = 'LANGUAGES';
const THEMES = 'THEMES';
const USER_LIST = 'USER_LIST';
const UPDATE_USER = 'UPDATE_USER';
const USER_STATUS = 'USER_STATUS';
const USER_AUTOCOMPLETE = 'USER_AUTOCOMPLETE';
const GROUP_LIST = 'GROUP_LIST';
const CHANGE_PIN = 'CHANGE_PIN';
const RESTORE_GROUP = 'RESTORE_GROUP';
const GROUP_DETAILS = 'GROUP_DETAILS';
const GROUP_MEMBERS_DETAILS = 'GROUP_MEMBERS_DETAILS';
const USERS_SCHEDULE_DATA = 'USERS_SCHEDULE_DATA';
const USER_PAUSE_AVAILABILITY = 'USER_PAUSE_AVAILABILITY';
const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
const NOTIFICATION_LIST = `NOTIFICATION_LIST`;
const DASHBOARD_STATS = `DASHBOARD_STATS`;
const PATIENT_LIST = `PATIENT_LIST`;
const SELLECTED_PATIENT = `SELLECTED_PATIENT`;
const USER_DOCUMENTS = `USER_DOCUMENTS`;
const BLAST_LIST = `BLAST_LIST`;
const REQUEST_LIST = `REQUEST_LIST`;
const INBOX_LIST = `INBOX_LIST`;
const TOPIC_LIST = `TOPIC_LIST`;
const ASSIGNED_TOPIC = `ASSIGNED_TOPIC`;
const CLINIC_LIST = `CLINIC_LIST`;
const CLINIC_DETAILS = `CLINIC_DETAILS`;
const ENCRYPTED_URL = `ENCRYPTED_URL`;
const REQUEST_DOCUMENTS = `REQUEST_DOCUMENTS`;
const DEPENDENT_USERS = `DEPENDENT_USERS`;
const PATEINT_MESSAGES = `PATEINT_MESSAGES`;
const UNREAD_MESSAGES_COUNT = `UNREAD_MESSAGES_COUNT`;
const SEARCH_PATIENTS = `SEARCH_PATIENTS`;
const SCRIBE_DASHBOARD = `SCRIBE_DASHBOARD`;
const SCRIBE_TEXT_MACRO = `SCRIBE_TEXT_MACRO`;
const SCRIBE_DIAGNOSIS_DATA = `SCRIBE_DIAGNOSIS_DATA`;

export default {
  UNREAD_MESSAGES_COUNT,
  USER_DOCUMENTS,
  DASHBOARD_STATS,
  AUTH_ME,
  USER_DESIGNATION,
  GET_HOLIDAY,
  CHANGE_PASSWORD,
  USER_PAUSE_AVAILABILITY,
  LANGUAGES,
  THEMES,
  USER_LIST,
  UPDATE_USER,
  USER_STATUS,
  USER_AUTOCOMPLETE,
  GROUP_LIST,
  CHANGE_PIN,
  RESTORE_GROUP,
  GROUP_DETAILS,
  GROUP_MEMBERS_DETAILS,
  USERS_SCHEDULE_DATA,
  NOTIFICATION_LIST,
  CREATE_ACCOUNT,
  PATIENT_LIST,
  SELLECTED_PATIENT,
  BLAST_LIST,
  REQUEST_LIST,
  INBOX_LIST,
  TOPIC_LIST,
  ASSIGNED_TOPIC,
  CLINIC_LIST,
  CLINIC_DETAILS,
  ENCRYPTED_URL,
  REQUEST_DOCUMENTS,
  DEPENDENT_USERS,
  PATEINT_MESSAGES,
  SEARCH_PATIENTS,
  SCRIBE_DASHBOARD,
  SCRIBE_TEXT_MACRO,
  SCRIBE_DIAGNOSIS_DATA,
};
